import { GetServerSideProps } from 'next/types';

import Layout from '@/components/layout/LayoutWrapper';
import PromotionMDX from '@/markdown/promotion-terms.mdx';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const PromotionalOfferTOS = () => {
	return (
		<Layout pageName="promotion-terms" title="Calm - Promotional Offer Terms">
			<PromotionMDX />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default PromotionalOfferTOS;
